export default __webpack_public_path__ + "static/media/bg_1.997b57b6.jpg";